<script setup>
</script>
<template>
    <section class="about section">
        <div class="about__container">
            <div class="about__content" data-animation-left>
                <h2 class="about__title title">ABOUT</h2>
                <div class="about__desc">
                    <p>Подарочный сертификат The Rink Fitness — это удобный способ подарить доступ к современному фитнес-пространству с высоким уровнем сервиса и вниманием к деталям. Он подходит как для личных, так и корпоративных подарков. И дает получателю широкие возможности для выбора формата тренировок и отдыха.</p>
                    <p>Вы можете приобрести сертификат на любую сумму или подарить конкретную услугу в The Rink Fitness.</p>
                </div>
            </div>
            <div class="about__image" data-animation-right>
                <img class='full-img' width='654' height='700' src='@/assets/img/about_img_1.webp' srcset='@/assets/img/about_img_1@2x.webp 2x' alt='изображение'>
            </div>
        </div>
    </section>
</template>
<style lang='scss' scoped>
</style>